<template>
  <div class="d-flex flex-column" style="height: 100%">
    <div
      class="row justify-content-start justify-content-md-center py-2 flex-wrap m-0"
    >
      <div class="d-flex align-items-center mx-2">
        <label class="event_count_label_g">0</label>
        <label class="m-0 event_label">目前訪客</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <label class="event_count_label_r">0</label>
        <label class="m-0 event_label">包裹未領</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <label class="event_count_label_r">0</label>
        <label class="m-0 event_label">退件未處理</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <label class="event_count_label_r">0</label>
        <label class="m-0 event_label">寄放未領</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <label class="event_count_label_r">0</label>
        <label class="m-0 event_label">意見未處理</label>
      </div>
    </div>
    <div class="flex-grow-1 Main_css">
      <div
        class="col-12 row m-0 align-items-center justify-content-between h-100 p-0"
      >
        <div
          class="justify-content-center d-flex align-items-center col-1 p-0 h-100"
          style="cursor: pointer"
          @click="changePage('Previous')"
        >
          <b-button class="d-flex align-items-center cust_page_btn"
            ><b-icon icon="triangle-fill" rotate="270"></b-icon
          ></b-button>
        </div>
        <div class="row m-0 col-10 p-0">
          <div
            class="col-12 col-md-4 d-flex justify-content-center"
            v-for="(item, index) in show_items"
            :key="index"
          >
            <div class="cust_card my-2 row" @click="GoAction(item.MENUNM)">
              <img :src="item.icon" style="width: 100%; height: 100%" />
              <!-- <div class="col-12 d-flex justify-content-center align-items-center"><img :src="item.icon"
                                    class="cust_card_icon">
                            </div>
                            <div class="col-12 mt-2"><label class="m-0" style="color: #844410; font-weight: 600;">{{
                                item.MENUNMC }}</label></div> -->
            </div>
          </div>
        </div>
        <div
          class="justify-content-center d-flex align-items-center col-1 p-0 h-100"
          style="cursor: pointer"
          @click="changePage('Next')"
        >
          <b-button class="d-flex align-items-center cust_page_btn"
            ><b-icon icon="triangle-fill" rotate="90"></b-icon
          ></b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      items: [
        {
          icon: require('@/assets/button/01_郵務管理.png'),
          READCD: 'True',
          MENUNMC: '郵務管理',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/02_寄放物品.png'),
          READCD: 'True',
          MENUNMC: '寄放物品',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/03_訪客登記.png'),
          READCD: 'True',
          MENUNMC: '訪客登記',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/04_社區公告.png'),
          READCD: 'True',
          MENUNMC: '社區公告',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/05_公設預約.png'),
          READCD: 'True',
          MENUNMC: '公設預約',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/06_雲講機.png'),
          READCD: 'True',
          MENUNMC: '雲對講',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/07_訂餐服務.png'),
          READCD: 'True',
          MENUNMC: '訂餐服務',
          MENUNM: 'MealOrderMain'
        },
        {
          icon: require('@/assets/button/08_報名活動.png'),
          READCD: 'True',
          MENUNMC: '報名活動',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/09_克麗緹娜SPA.png'),
          READCD: 'True',
          MENUNMC: '克麗緹娜SPA',
          MENUNM: 'SpaMain'
        },
        {
          icon: require('@/assets/button/10_預約看診.png'),
          READCD: 'True',
          MENUNMC: '預約看診',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/11_健康顧問.png'),
          READCD: 'True',
          MENUNMC: '健康顧問',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/12_智慧家電.png'),
          READCD: 'True',
          MENUNMC: '智慧家電',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/13_個人行事曆.png'),
          READCD: 'True',
          MENUNMC: '個人行事曆',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/14_社區行事曆.png'),
          READCD: 'True',
          MENUNMC: '社區行事曆',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/15_叫車服務.png'),
          READCD: 'True',
          MENUNMC: '叫車服務',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/16_周邊店家.png'),
          READCD: 'True',
          MENUNMC: '周邊店家',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/17_線上購物.png'),
          READCD: 'True',
          MENUNMC: '線上購物',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/18_巴士即時動態.png'),
          READCD: 'True',
          MENUNMC: '巴士即時動態',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/19_點數管理.png'),
          READCD: 'True',
          MENUNMC: '點數管理',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/20_月結帳單.png'),
          READCD: 'True',
          MENUNMC: '月結帳單',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/21_住戶反映.png'),
          READCD: 'True',
          MENUNMC: '住戶反映',
          MENUNM: 'User'
        },
        {
          icon: require('@/assets/button/22_推撥通知.png'),
          READCD: 'True',
          MENUNMC: '推撥通知',
          MENUNM: 'User'
        }
      ],
      show_items: [],
      page: 0,
      total_page: 0
    };
  },
  watch: {},
  mounted() {
    this.calcTotalPage();
  },
  methods: {
    calcTotalPage() {
      this.total_page = Math.floor(this.items.length / 6);
      //console.log(this.total_page)
      this.show_items = this.items.slice(0, 6);
    },
    changePage(type) {
      let perpage = 6;
      if (type == 'Previous') {
        if (this.page == 0) {
          this.page = this.total_page;
        } else {
          this.page = this.page - 1;
        }
        this.show_items = this.items.slice(
          this.page * perpage,
          this.page * perpage + perpage
        );
      } else if (type == 'Next') {
        if (this.page == this.total_page) {
          this.page = 0;
        } else {
          this.page = this.page + 1;
        }
        this.show_items = this.items.slice(
          this.page * perpage,
          this.page * perpage + perpage
        );
      }
    },
    GoAction(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>
<style scoped>
.event_count_label_g {
  border-radius: 6px;
  margin: 0 !important;
  background-color: #69a835;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_count_label_r {
  border-radius: 6px;
  margin: 0 !important;
  background-color: #c62e67;
  color: white;
  font-weight: 600;
  padding: 2px 8px 2px 8px;
}

.event_label {
  margin-left: 10px !important;
  font-size: 1.5rem;
  color: #8b868b;
  font-weight: 600;
}

.Main_css {
  background-color: #f4dcb9;
}

.cust_card_icon {
  width: 65px;
  height: 65px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; 
    border: 1px solid white;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 1px 1px 1px 1px #CBB79A; */
  width: 200px;
  height: 130px;
  cursor: pointer;
}

.cust_page_btn {
  height: 45px;
  width: 30px;
  padding: 0;
  justify-content: center;
  background-color: #ec6c01;
  border: #ec6c01;
}
</style>



// WEBPACK FOOTER //
// src/components/View/MainPage.vue